import { CarregaService } from '../services/carrega_file/carrega.service';
import { HttpClient } from '@angular/common/http';
import { Component, ElementRef, ViewChild } from '@angular/core';
import { format } from 'date-fns';
import { ApiService } from '../services/contratos/contratos.service';
import { MatDialog } from '@angular/material/dialog';
import { DatePipe } from '@angular/common';

@Component({
    selector: 'app-time-table-sese',
    templateUrl: './time-table-sese.component.html',
    styleUrls: ['./time-table-sese.component.css'],
    standalone: false
})



export class TimeTableSESEComponent {

  constructor(
    private carregaService: CarregaService,
    private http: HttpClient,
    private dynamodbService: ApiService,
    public dialog: MatDialog,
    private datePipe: DatePipe
  ) { }

  item: any = {
    ID: '',
    Transportadora: '',
    Plate: '',
    ['Local 1']: '',
    ['Local 2']: '',
    ['Local 3']: '',
    ['Local 4']: '',
    ['Local 5']: '',
    ['Local 6']: '',
    ['Janela 1']: '',
    ['Janela 2']: '',
    ['Janela 3']: '',
    ['Janela 4']: '',
    ['Janela 5']: '',
    ['Janela 6']: '',

  };

  progressValue = 0; // Valor atual da barra de progresso
  maxValue = 0; // Valor máximo da barra de progresso
  showProgressBar = false;
  @ViewChild('downloadLink') downloadLink!: ElementRef<HTMLAnchorElement>;
  urlAtualiza: string = 'https://uj88w4ga9i.execute-api.sa-east-1.amazonaws.com/dev12';
  urlConsulta: string = 'https://fopq9ohj7e.execute-api.sa-east-1.amazonaws.com/v1';
  query: string = 'timeTableSESE';
  query2: string = 'Carriers';
  query3: string = 'Locais_Karrara_Transport';
  queryVeiculos: string = 'veiculos_lab_Karrara';
  dataLoaded = false;
  jsonData: any;
  sortColumn: string = '';
  sortDirection: number = 1;
  dias_terminal: Date = new Date();
  Freetime: number = 0;
  dados: any[] = [];
  contratos: string[] = [];
  freetime: string[] = [];
  tripcost: string[] = [];
  custoViagem: string = "";
  handling: string[] = [];
  manuseio: string = "";
  demurrage: string[] = [];
  estadia: string = "";
  valorFree: string = '';
  liner: string = "";
  vessel: string = "";
  custoestadia: number = 0;
  startDate!: Date;
  endDate: Date = new Date();
  editMode!: boolean[];
  informationMode!: boolean[];
  programacao: any[] = [];
  dialogOpen!: boolean;
  janela: string = '';
  janela1: string = '';
  janela2: string = '';
  janela3: string = '';
  janela4: string = '';
  janela5: string = '';
  janela6: string = '';
  places!: any[];
  carriers!: any[];
  transportadora!: string[];
  locais!: string[];
  veiculos!: any[];
  isLoading: boolean = true;

  async ngOnInit() {
    await this.getProgramacaoFromDynamoDB();
    await this.getPlacesFromDynamoDB();
    await this.getCarriersFromDynamoDB();
    await this.getVeiculosFromDynamoDB();
    this.isLoading = false;
    // //console.log(this.programacao);
  }

  editDialog(item: any): void {
    // //console.log(item)
    this.item = { ...item }
    if (Array.isArray(this.carriers)) {
      this.transportadora = this.carriers.map(carrier => carrier.name);
    } else {
      // Trate o caso em que this.carriers não é um array ou é undefined
      // Por exemplo, atribua um array vazio a this.transportadora ou faça alguma outra ação apropriada.
    }

    if (Array.isArray(this.places)) {
      this.locais = this.places.map(places => places.local);
    } else {
      // Trate o caso em que this.carriers não é um array ou é undefined
      // Por exemplo, atribua um array vazio a this.transportadora ou faça alguma outra ação apropriada.
    }

    if (item.ID === undefined || item.ID === '') {
      this.janela = '';
    } else {
      const horaMinuto = this.datePipe.transform(item['Janela'], 'HH:mm', '+00:00');
      this.janela = horaMinuto ?? this.janela;
    }
    // this.item.ID = item.ID
    // this.item.Transportadora = item.Transportadora;
    this.item.Plate = item.Plate ? item.Plate.replace(/[^a-zA-Z0-9]/g, '') : '';
    // this.item.trailerPlate = item.trailerPlate;
    // this.item.rota = item.rota;
    // this.item.viagem = item.viagem;
    // this.item.percurso = item.percurso;
    // this.item.observacao = item.observacao;
    // this.item['Local'] = item['Local'];
    // this.item['Janela'] = item['Janela'];
    this.dialogOpen = true;
  }

  async salvar2(item: any) {
    this.isLoading = true;
    const datapadrao = '2006-04-04';
    const janela = this.carregaService.adicionarHora(this.janela, new Date(datapadrao));
    // const janela = new Date(datapadrao);
    // //console.log(janela)
    if (this.item.ID === undefined) {
      const currentDate = new Date();
      const formattedDate = format(currentDate, 'ddMMyyyyHHmmss');
      // //console.log(formattedDate);
      this.item.ID = formattedDate.toString();
    }
    this.item['Janela'] = janela;
    this.item.tableName = this.query
    // //console.log(this.veiculos)
    // this.item['Transport Type'] = this.veiculos.find(item => item.placa === this.item.Plate)?.modelo;
    this.item['Transport Type'] = await this.veiculos.find(item => item.placa.replace(/\s/g, '') === this.item.Plate.replace(/\s/g, ''))?.modelo;
    if (item['Transport Type']) {
      // //console.log(this.item['Transport Type'])
      // Remover as barras invertidas escapadas
      const itemsDataString = JSON.stringify(this.item); // Acessa a string desejada
      const modifiedString = itemsDataString.replace(/\\"/g, '"'); // Realiza a substituição na string
      // Converter a string JSON para um objeto JavaScript
      const jsonObject = JSON.parse(modifiedString) as { [key: string]: string };
      // Converter o objeto JavaScript de volta para uma string JSON
      const modifiedJsonString = JSON.stringify(jsonObject);
      // //console.log(modifiedJsonString);
      // Converter a string JSON para um objeto JavaScript
      const jsonObject2 = JSON.parse(modifiedJsonString) as { tableName: string, ID: string, acao: string };
      // Criar um array contendo o objeto
      const jsonArray = [jsonObject2];
      // //console.log(jsonArray);

      await this.dynamodbService.salvar(jsonArray, this.query, this.urlAtualiza).subscribe(async response => {
        await this.ngOnInit();
        // //console.log(response)
        this.dialogOpen = false;
        this.isLoading = false;
      }, error => {
        console.log(error);
      });
    } else {
      const confirmacao = window.confirm("A placa inseririda, não esta cadastrada !");
      // Verifica se o usuário confirmou a ação
      if (confirmacao) {
        this.isLoading = false;
      }
    }
  }

  cancel(): void {
    this.dialogOpen = false;
  }

  async getProgramacaoFromDynamoDB(): Promise<void> {
    const filtro = '';
    (await this.dynamodbService.getItems(this.query, this.urlConsulta, filtro)).subscribe(
      (response: any) => {
            // console.log(response)

        if (response.statusCode === 200) {
          try {
            const items = JSON.parse(response.body);
            // //console.log(items)
            if (Array.isArray(items)) {
              this.programacao = items.map(item => ({ ...item, checked: false }));
              // Adiciona a chave 'checked' a cada item, com valor inicial como false
              this.programacao = this.programacao.sort((a, b) => {
                if (a.rota < b.rota) return -1;
                if (a.rota > b.rota) return 1;
                if (a.Janela < b.Janela) return -1;
                if (a.Janela > b.Janela) return 1;

                return 0;
              });
              // //console.log(this.programacao)

            } else {
              console.error('Invalid items data:', items);
            }
          } catch (error) {
            console.error('Error parsing JSON:', error);
          }
        } else {
          console.error('Invalid response:', response);
        }
      },
      (error: any) => {
        console.error(error);
      }
    );
  }

  async getPlacesFromDynamoDB(): Promise<void> {
    const filtro = '';
    (await this.dynamodbService.getItems(this.query3, this.urlConsulta, filtro)).subscribe(
      (response: any) => {
        if (response.statusCode === 200) {
          try {
            const items = JSON.parse(response.body);
            if (Array.isArray(items)) {
              this.places = items.map(item => ({ ...item, checked: false }));
              // Adiciona a chave 'checked' a cada item, com valor inicial como false
            } else {
              console.error('Invalid items data:', items);
            }
          } catch (error) {
            console.error('Error parsing JSON:', error);
          }
        } else {
          console.error('Invalid response:', response);
        }
      },
      (error: any) => {
        console.error(error);
      }
    );
  }

  async getVeiculosFromDynamoDB(): Promise<void> {
    const filtro = '';
    (await this.dynamodbService.getItems(this.queryVeiculos, this.urlConsulta, filtro)).subscribe(
      (response: any) => {
        if (response.statusCode === 200) {
          try {
            const items = JSON.parse(response.body);
            if (Array.isArray(items)) {
              this.veiculos = items.map(item => ({ ...item, checked: false }));
              // //console.log(this.veiculos)
              // Adiciona a chave 'checked' a cada item, com valor inicial como false
            } else {
              console.error('Invalid items data:', items);
            }
          } catch (error) {
            console.error('Error parsing JSON:', error);
          }
        } else {
          console.error('Invalid response:', response);
        }
      },
      (error: any) => {
        console.error(error);
      }
    );
  }

  async getCarriersFromDynamoDB(): Promise<void> {
    const filtro = '';
    (await this.dynamodbService.getItems(this.query2, this.urlConsulta, filtro)).subscribe(
      (response: any) => {
        if (response.statusCode === 200) {
          try {
            const items = JSON.parse(response.body);
            if (Array.isArray(items)) {
              this.carriers = items.map(item => ({ ...item, checked: false }));
              // Adiciona a chave 'checked' a cada item, com valor inicial como false
            } else {
              console.error('Invalid items data:', items);
            }
          } catch (error) {
            console.error('Error parsing JSON:', error);
          }
        } else {
          console.error('Invalid response:', response);
        }
      },
      (error: any) => {
        console.error(error);
      }
    );
  }

  async salvarNoBanco() {
    this.showProgressBar = true;
    //console.log('Item a ser salvo:', this.jsonData);
    this.progressValue = 0;
    this.maxValue = this.jsonData.length;
    const batchSize = 10; // Defina o tamanho máximo para cada lote
    const batches = this.chunkArray(this.jsonData, batchSize); // Fraciona o jsonData em lotes menores

    for (const batch of batches) {
      // Acrescentar o campo "lastupdate" com o valor da data de hoje
      const currentDate = new Date();
      const formattedDate = currentDate.getDate().toString().padStart(2, '0') +
        (currentDate.getMonth() + 1).toString().padStart(2, '0') +
        currentDate.getFullYear().toString();
      for (const item of batch) {
        item.lastupdate = formattedDate;
      }
      this.progressValue = this.progressValue + batch.length;
      await this.dynamodbService.salvar(batch, this.query, this.urlAtualiza).subscribe(
        response => {
          this.showProgressBar = false;
          //console.log('Resposta do salvamento:', response);
        },
        error => {
          console.error('Erro ao salvar:', error);
        }
      );
    }
  }

  toggleEditMode(index: number): void {
    this.editMode[index] = !this.editMode[index];
  }
  toggleInformationMode(index: number): void {
    this.informationMode[index] = !this.informationMode[index];
  }

  // acaoDeClique(item: any, NomePasso: string, NomeBotao: string, NomeDestino: string) {
  //   if (item[NomeBotao] === false) {
  //     // Executa ação 1
  //     this.editDialog(item[NomeDestino]);
  //   } else {
  //     // Executa ação 2
  //     this.finalizaPasso(NomePasso, item);
  //   }
  // }

  // async finalizaPasso(Passo: string, item: any) {
  //   await this.salvarNoBanco();
  //   // setTimeout(() => {
  //   await this.ngOnInit();
  //   // }, 1500);


  // }


  chunkArray(array: any[], size: number): any[][] {
    const chunks = [];
    for (let i = 0; i < array.length; i += size) {
      chunks.push(array.slice(i, i + size));
    }
    return chunks;
  }


  async salvar() {
    // this.isLoading = true;
    if (this.startDate === undefined) {
      alert('Selecione a data');
      return; // Retorna imediatamente para interromper a execução da função
    }
    const currentDate = new Date();
    const hours = currentDate.getHours();
    const minutes = currentDate.getMinutes();
    const seconds = currentDate.getSeconds();
    const totalSeconds = hours * 3600 + minutes * 60 + seconds;
    const formattedDate = currentDate.getDate().toString().padStart(2, '0') +
      (currentDate.getMonth() + 1).toString().padStart(2, '0') +
      totalSeconds.toString() +
      currentDate.getFullYear().toString();
    const data = new Date(this.startDate);
    data.setHours(data.getHours());
    let i = 0;
    this.programacao.forEach(objeto => {
      // console.log(objeto['Janela'])
      let dateString = objeto['Janela'];  // Acessar a propriedade 'Janela 1' do objeto
      // //console.log(dateString)
      let dateStringSemZ = dateString.replace("Z", "");
      let date = new Date(dateStringSemZ);
      // //console.log(date)
      let hours = ('0' + date.getHours()).slice(-2);
      let minutes = ('0' + date.getMinutes()).slice(-2);
      let seconds = ('0' + date.getSeconds()).slice(-2);
      const timeString1 = hours + ':' + minutes + ':' + seconds;
      let janela = this.carregaService.adicionarHora(timeString1, new Date(data));
      // console.log(this.startDate)
      // console.log(data)
      // console.log(janela)
      // console.log(hours)
      let horaCompara = parseInt(hours);
      if (horaCompara >= 0 && horaCompara < 5){
        let today = new Date(janela);
        today.setDate(today.getDate() + 1);
        // console.log(today);
        janela = today;
      }
      objeto.ID = formattedDate + i;
      objeto.tableName = 'Operacao_Interplantas_Karrara';
      objeto['Janela'] = janela;
      i++;
    });

    await this.programacao.forEach(prog => {
      prog.created = new Date().getTime()
      prog.date = prog.Janela
      prog['Transport Type'] = this.veiculos.find(item => item.placa === prog.Plate)?.modelo;
      prog['Fornecedor 1'] = 'LCB'
      prog['Weight Loaded'] = (prog.Local != 'E37' ? 25000 : 8800)
      prog.Volumes = 0
      prog.Cubage = 0
      prog['Total Distance'] = 16.6
      prog['Total Cost'] = 0
    })

    await this.programacao.forEach(item => {
      item.capacidadePeso = this.veiculos.find(veiculo => veiculo.modelo == item['Transport Type']) ? this.veiculos.find(veiculo => veiculo.modelo == item['Transport Type']).peso : 0
      item.capacidadeVolumetrica = this.veiculos.find(veiculo => veiculo.modelo == item['Transport Type']) ? this.veiculos.find(veiculo => veiculo.modelo == item['Transport Type']).volume : 0
      item.veiculoPerfil = this.veiculos.find(veiculo => veiculo.modelo == item['Transport Type']) ? this.veiculos.find(veiculo => veiculo.modelo == item['Transport Type']).perfil : 'Não encontrado'
      item.emissao = this.veiculos.find(veiculo => veiculo.modelo == item['Transport Type']) ? this.veiculos.find(veiculo => veiculo.modelo == item['Transport Type']).emissoes : 0
      item.consumo = this.veiculos.find(veiculo => veiculo.modelo == item['Transport Type']) ? this.veiculos.find(veiculo => veiculo.modelo == item['Transport Type']).consumo : 0
      item.emissaoTotal = (item['Total Distance'] * item.emissao) / item.consumo;
      // item.emissaoTotal = (distance * emissao) / consumo;
      // //console.log(item.capacidadeVolumetrica)
    })

    // Atualizando o array se necessário (opcional)
    this.programacao = [...this.programacao];
    //console.log(this.programacao)
    // Remover as barras invertidas escapadas
    const itemsDataString = JSON.stringify(this.programacao); // Acessa a string desejada
    const modifiedString = itemsDataString.replace(/\\"/g, '"'); // Realiza a substituição na string
    // Converter a string JSON para um objeto JavaScript
    const jsonObject = JSON.parse(modifiedString) as { [key: string]: string };
    // Converter o objeto JavaScript de volta para uma string JSON
    const modifiedJsonString = JSON.stringify(jsonObject);
    ////console.log(modifiedJsonString);
    // Converter a string JSON para um objeto JavaScript
    const jsonObject2 = JSON.parse(modifiedJsonString) as { tableName: string, ID: string, acao: string };
    // Criar um array contendo o objeto
    const jsonArray = [jsonObject2];
    // //console.log(jsonObject2)
    await this.dynamodbService.salvar(jsonObject2, 'table - passada no body', this.urlAtualiza).subscribe(async response => {
      await this.getProgramacaoFromDynamoDB();
      alert('Concluído com sucesso');
      this.isLoading = false;
    }, error => {
      console.log(error);
    });
  }

  async deleteItem(ID: string): Promise<void> {
    await this.dynamodbService.deleteItem(ID, this.urlAtualiza, this.query).subscribe(
      async response => {
        // setTimeout(() => {
        await this.getProgramacaoFromDynamoDB();
        // }, 400); // Ajuste o tempo de atraso conforme necessário
      },
      error => {
        // Lógica para lidar com erros durante a deleção do item
      }
    );
  }
}
